import PageContent from "../PageContent/PageContent";
import { useEffect } from "react";

import InfoCover from "../PageContent/PageCovers/InfoCover";
import PropShow from "../PageContent/PropShow";
import BrancoAnim from "../PageContent/BrancoAnim";
import VideoAsk from "../PageContent/VideoAsk";
import Two from "../PageContent/Two";
import Fancy from "../PageContent/Fancy";
import PinkForm from "../PageContent/PinkForm";
import Footer from "../PageContent/Footer";
import CTAButton from "../PageContent/CTAButton";
import Map from "../PageContent/MapPart";
import Marquee from "../PageContent/Marquee";
import QuestionBox from "../PageContent/QuestionBox";
import AccordionText from "../PageContent/AccordionText";

const questionBoxData = {
  title: "Geheel vrijblijvend kennismaken!",
  text: [
    "LUISTER EVEN NAAR ONS VERHAAL EN LAAT VHENGA U DAARVOOR DIK BELONEN.",
  ],
  button: "NEEM HIERONDER CONTACT MET ONS",
};

function Contact({ page, title, text }) {
  useEffect(() => {
    document.title = title ? title : page;
  }, [title, page]);

  return (
    <div className="content-ctnr">
      <PinkForm page={page} text={text} />
      <Map />
      <Footer page={page} text={text} />

      <CTAButton page={page} />
    </div>
  );
}

export default Contact;
